import "./PriceTickerInputComponent.scss";
import {IComponentOptions} from "angular";
import {PriceStrategy} from "../price/input/PriceStrategy";
import {ComponentCallback} from "../../../types/AngularJS";

export const PriceTickerInput = "tfPriceTicker";

export function priceTickerInput(): IComponentOptions {
    return {
        templateUrl: "app/components/inputs/price-ticker/PriceTickerInputComponent.html",
        bindings: {
            name: "@",
            placeholder: "@",
            price: "<",
            strategy: "<",
            min: "<",
            max: "<",
            allowZero: "<",
            required: "<",
            disabled: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: PriceTickerInputComponentController
    };
}

export class PriceTickerInputComponentController {

    public name: string | null;
    public placeholder: string | null;
    public price: number | null;
    public strategy: PriceStrategy | null;
    public min: number | null;
    public max: number | null;
    public allowZero: boolean | null;
    public required: boolean | null;
    public disabled: boolean | null;
    public onChange: ComponentCallback;

    public tickUp() {
        if (this.strategy != null && this.price != null) {
            const newPrice = this.strategy.tickUp(this.price);
            this.onChange({price: newPrice});
        }
    }

    public tickDown() {
        if (this.strategy != null && this.price != null) {
            const newPrice = this.strategy.tickDown(this.price);
            this.onChange({price: newPrice});
        }
    }
}
